// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarComments-cls1_bOp","cls2":"SidebarComments-cls2_pH3 SidebarComments-cls1_bOp"};